import { initializeApp } from 'firebase/app'
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth'

const firebaseApp = initializeApp(JSON.parse(process.env.VUE_APP_FIREBASE_CREDENTIALS));
const auth = getAuth(firebaseApp);
await setPersistence(auth, browserLocalPersistence);

export { auth, firebaseApp };
